$(document).ready(function () {
    $('.ch').change(function () {
        $('#filter-submit').click();
    });

    $('.remove-filter').click(function (e) {
        $('#styled-checkbox-' + e.target.id).prop("checked", false);
        $('#filter-submit').click();
    });

    $('.clear-brands').click(function (e) {
        $('.brand').prop("checked", false);
        $('#filter-submit').click();
    });
});

$(document).on('click', '.update-basket', function (event) {
    event.preventDefault();

    var item = $(this).data('id');
    var finance = $(this).data('finance');
    var quantity = $('.input-number').val();
    var variation = $(this).data('v');

    if (item === '' || quantity === '' || finance === '')
        return;

    $.ajax({
        method: 'GET',
        dataType: 'json',
        data: {item: item, finance: finance, quantity: quantity, variation: variation},
        url: $(this).attr('data-url'),
        success: function (response) {

            if (response.success) {

                $('html, body').animate({scrollTop: 0}, '300');

                $('.header-login .cta-button--primary.top').addClass('basket-toggle').html(response.totalQuantity + (response.totalQuantity > 1 ? " Items " : " Item ") + '<i class="fa fa-shopping-cart"></i>');
                $('#overlay').show();

                $('#basket-contents .mp').html('<p>' + response.maxPoints + ' points to spend</p>');
                $('#basket-contents .cart').html('<p>' + response.totalQuantity + (response.totalQuantity > 1 ? " Items " : " Item ") + '<i class="fa fa-shopping-cart"></i>');
                $('#basket-contents .qt').html('<p>' + response.totalQuantity + (response.totalQuantity > 1 ? " Items " : " Item ") + 'in your basket</p>');
                $('#basket-contents .pt').html('<p>' + response.totalPoints + ' Points</p>');

                var itemHtml = '';

                $.each(response.items, function (i, bItem) {
                    $.each(bItem, function (i, item) {
                        itemHtml += '<div class="item-holder">' +
                            '<div class="row">' +
                            '<div class="col-md-6">' +
                            '<img src="' + item.image + '" width="150" alt="banner">' +
                            '</div>' +
                            '<div class="col-md-6"><h5>' + item.item.name + '</h5> <p class="points">' + item.points + ' Points</p>' +
                            '<p class="quantity">Quantity: ' + item.quantity + '</p>' +
                            '</div>' +
                            '</div>' +
                            '' +
                            '<div class="clearfix"></div>' +
                            '' +
                            '</div>';
                    });
                });

                $('#basket-items').html(itemHtml);
                itemHtml = '<div class="row"><div class="col-md-12 remaining"><p>Remaining: <span>' + (response.maxPoints - response.totalPoints) + ' points</span></p></div></div>';
                $('#basket-bottom').html(itemHtml);
                $('#basket-contents').slideDown(500);


            } else {
                $('#basket-response').addClass('alert-danger').text(response.message).slideDown(500).delay(1500).slideUp(500);
            }

        }
    });
});


$(document).on('shown.bs.modal', '#confirm-submit', function (e) {
    $('#modal-submit').on('click', function (e) {
        e.preventDefault();
        $('#basket-from').submit();
    });
});

$('.cta-checkout').click(function (e) {
    e.preventDefault();
    //console.log('no sub');
});

$('.update-basket-2').click(function (e) {
    e.preventDefault();

    fieldName = $(this).attr('data-field');
    type = $(this).attr('data-type');
    var input = $("input[name='" + fieldName + "']");

    var currentVal = parseInt(input.val());

    if (!isNaN(currentVal)) {
        if (type == 'minus') {

            if (currentVal > input.attr('min')) {
                input.val(currentVal - 1).change();
            }
            if (parseInt(input.val()) == input.attr('min')) {
                $(this).attr('disabled', true);
            }

        } else if (type == 'plus') {

            if (currentVal < input.attr('max')) {
                input.val(currentVal + 1).change();
            }
            if (parseInt(input.val()) == input.attr('max')) {
                $(this).attr('disabled', true);
            }

        }
    } else {
        input.val(0);
    }

    var item = $(this).closest('.input-group').find('input').data('id');
    var finance = $(this).closest('.input-group').find('input').data('finance');
    var quantity = $(this).closest('.input-group').find('input').val();
    var type = $(this).attr('data-type');
    //var input = $(this).closest('.input-group').find('input');
    var variation = $(this).closest('.input-group').find('input').data('v');

    if (item === '' || quantity === '' || finance === '')
        return;

    $.ajax({
        method: 'GET',
        dataType: 'json',
        data: {item: item, finance: finance, quantity: quantity, type: type, variation: variation},
        url: $('#basket-response').attr('data-basket-update-url'),
        success: function (response) {

            if (response.success) {

                $('.ip' + [item] + '-' + [finance]).html(response.items[item][finance].points * response.items[item][finance].quantity + ' points');

                $('.tp').html('<h3>' + response.totalPoints + ' Points</h3>');
                $('.pr').html('<h3>' + response.remainingPoints + ' Points</h3>');
                $('.mtp').html('<h3>Total: ' + response.totalPoints + ' Points</h3>');
                $('.mpr').html('<h3>Remaining: ' + response.remainingPoints + ' Points</h3>');
                $('.ti').html(response.totalQuantity + (response.totalQuantity > 1 ? " Items" : " Item"));

            } else {

                $(this).closest('.update-basket-2').attr('disabled', true);

                input.val(quantity - 1).change();

                if (parseInt(input.val()) == input.attr('min')) {
                    $(this).attr('disabled', true);
                }

                $('#basket-response').addClass('alert-danger').text(response.message).slideDown(500).delay(1500).slideUp(500);
            }

        }
    });

});

$('.remove-item').click(function (e) {
    e.preventDefault();

    var id = $(this).attr('data-id');
    var row = $(this).closest(".item-row");

    if (id === '')
        return;

    $.ajax({
        method: 'GET',
        dataType: 'json',
        data: {basket_item: id},
        url: $('#basket-response').attr('data-basket-remove-item'),
        success: function (response) {

            if (response.success) {
                $('.mtp').html('<h3>Total: ' + response.totalPoints + ' Points</h3>');
                $('.mpr').html('<h3>Remaining: ' + response.remainingPoints + ' Points</h3>');
                $('.pr').html('<h3>' + response.totalPoints + ' Points</h3>');
                $('.tp').html('<h3>' + response.totalPoints + ' Points</h3>');
                $('.ti').html(response.totalQuantity + ' Items');
                row.remove();
            } else {
                alert('Something went wrong!')
            }

        }
    });

});
